import glossary from './glossary.js';

const locale = navigator.language || 'en-US';
const defaultLang = 'en';
const defaultError = glossary.default?.[defaultLang];

export default function getErrorMessage(errorCode) {
    const lang = locale.slice(0, 2);

    return glossary[errorCode]?.[lang] || glossary[errorCode]?.[defaultLang] || glossary.default?.[lang] || defaultError;

}